'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { tap } from 'rxjs/operators/tap';
import ContentRoutes from 'ContentUtils/Routes';
import { DELETED_CONTENT } from '../actions/ActionTypes';
import { closeModal } from '../actions/ModalActions';
import { receiveContent, requestContent, requestDeleteContent, requestedContentFailed, requestedDeleteContentFailure, requestedDeleteContentSuccess } from '../actions/ContentActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(DELETED_CONTENT).pipe(mergeMap(({
  payload: {
    categoryId,
    contentId,
    contentType,
    id,
    newMasterId,
    onPageChange
  }
}) => {
  const reloadPage = ContentClient.fetchContent({
    contentPageId: contentId,
    contentType
  }).pipe(mergeMap(content => of(closeModal(), receiveContent(content), requestedDeleteContentSuccess(contentType))), catchError(error => of(requestedContentFailed(error))), startWith(requestContent()));

  const sendToDashboard = () => {
    window.location.href = ContentRoutes.dashboard(categoryId);
  };

  const responseAction = contentId === id ? newMasterId && id !== newMasterId ? [mergeMap(() => of(onPageChange(newMasterId), closeModal(), requestedDeleteContentSuccess(contentType)))] : [mergeMap(() => of(closeModal(), requestedDeleteContentSuccess(contentType))), tap(sendToDashboard)] : [mergeMap(() => reloadPage)];
  return ContentClient.deleteContent(contentType, id).pipe(...responseAction, catchError(error => of(requestedDeleteContentFailure(error, contentType))), startWith(requestDeleteContent()));
})));